import { render, staticRenderFns } from "./MessageCell.vue?vue&type=template&id=633146a1&scoped=true&"
import script from "./MessageCell.vue?vue&type=script&lang=js&"
export * from "./MessageCell.vue?vue&type=script&lang=js&"
import style0 from "./MessageCell.vue?vue&type=style&index=0&id=633146a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633146a1",
  null
  
)

export default component.exports